import styles from "./SignatureModal.module.css";
import {
  useSignatureContinueModal,
  type PropertyRelationshipSubmission,
} from "@/features/protest/viewModal/signatureViewmodal";
import { ProtestSuccessContent } from "./ProtestSuccessModal";
import { Modal } from "@/shared/modal";

type SignatureModalProps = {
  isOpen: boolean;
  selectedPropertyTypes?: Record<string, "RESIDENTIAL" | "COMMERCIAL" | "LAND_LOT" | "LAND_OR_LOT">;
  propertyRelationships?: Record<string, PropertyRelationshipSubmission>;
  paidPropertyIds?: string[];
  onClose: () => void;
  onSubmit?: () => void;
};

export const SignatureModal = (props: SignatureModalProps) => {
  const vm = useSignatureContinueModal(props);

  return (
    <Modal
      isOpen={vm.visible}
      onClose={vm.onClose}
      showCloseButton={false}
      closeOnBackdropClick={false}
      unconstrained
      className={styles.content}
      bodyClassName={styles.continueModalBody}
      ariaLabel="Continue details"
    >
      <button
        type="button"
        className={styles.closeBtn}
        onClick={vm.onClose}
        aria-label="Close continue modal"
      >
        ✕
      </button>

      {vm.isSuccessModalOpen && (
        <ProtestSuccessContent
          onContinue={vm.onSuccessContinue}
          redirectSeconds={vm.successRedirectSeconds}
        />
      )}

      {!vm.isSuccessModalOpen && (
        <div className={styles.signatureBlock}>
          <h3 className={styles.signatureTitle}>Provide Your Signature</h3>
          <div className={styles.signatureSubTitle}>
            Your signature will be applied to all forms.
          </div>

          <div className={styles.signaturePad}>
            <div className={styles.signaturePadText}>
              <canvas
                ref={vm.signatureCanvasRef}
                className={styles.signatureCanvas}
                onMouseDown={vm.startDrawing}
                onMouseMove={vm.draw}
                onMouseUp={vm.stopDrawing}
                onMouseLeave={vm.stopDrawing}
                onTouchStart={vm.startDrawing}
                onTouchMove={vm.draw}
                onTouchEnd={vm.stopDrawing}
              />
            </div>
            <button
              type="button"
              className={styles.clearBtn}
              onClick={vm.clearSignature}
              disabled={!vm.signature}
              aria-disabled={!vm.signature}
            >
              Clear
            </button>
          </div>

          <label className={styles.consentRow} htmlFor="signature-consent-checkbox">
            <input
              id="signature-consent-checkbox"
              type="checkbox"
              className={styles.consentCheckbox}
              checked={vm.signatureConsentAccepted}
              onChange={(event) => vm.setSignatureConsentAccepted(event.target.checked)}
            />
            <span className={styles.signatureDisclaimer}>
              By signing, you agree that your electronic signature is the legal equivalent of your
              manual signature on these documents.
            </span>
          </label>
        </div>
      )}

      {!vm.isSuccessModalOpen && (
        <div className={styles.footer}>
          <button
            type="button"
            className={styles.payBtn}
            onClick={() => void vm.handleSubmit()}
            disabled={
              !vm.signature ||
              !vm.propertyId.trim() ||
              !vm.signatureConsentAccepted ||
              vm.isSubmitting
            }
            aria-disabled={
              !vm.signature ||
              !vm.propertyId.trim() ||
              !vm.signatureConsentAccepted ||
              vm.isSubmitting
            }
          >
            {vm.isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      )}
    </Modal>
  );
};
